<template>
  <div>
      <div class="repeated-booking row ">
          <div class="col-md-12 repeating-booking-hint">
              <span style="color: red">Note : </span>
              <span class="repeated-booking-message"> Changes will be applied to all related repeated bookings vue</span>
          </div>
          <div class="table-changes"></div>
          <div class="col-md-12 text-center">
              <div class="col-md-12 changes-title no-padding-left" style="margin-top: 10px;">Related repeated bookings
              </div>
              <div class="col-md-12 no-padding-left" style="max-height:400px;overflow-y: auto">
                  <table class="table table-striped repeating-booking-table">
                      <thead>
                      <tr>
                          <th style="text-align: center">Booking</th>
                          <th style="text-align: center">Status</th>
                          <th style="text-align: center">Selection</th>
                      </tr>
                      </thead>
                      <tbody>
                          <tr>
                              <td  data-id="-1">All</td>
                              <td>Name</td>
                              <td style="padding-left: 0;padding-right: 30px;"  data-id="-1">
                                  <div class="material-switch repeating-bookings">
                                      <input id="check-all-repeated-bookings-new" type="checkbox" v-model="selectAll"  @change="toggleSelectAll">
                                      <label  :for="'check-all-repeated-bookings-new'" class="label-default-repeat-all" id="check-all-repeated-bookings-label"></label>
                                  </div>
                              </td>
                          </tr>
                          <tr v-for="(recurring, index) in recurringBookings" :key="index">
                              <td>
                                  <a :href="'/booking/view/' + recurring.booking_id" target="_blank">
                                      {{ recurring.booking_num }}
                                  </a>
                                  <img style="display: none" class="repeated_bookings_loading" :id="'repeated_bookings_loading'+ recurring.booking_id"  src="/pic/loading-4.gif">
                              </td>
                              <td>
                                  {{ recurring.name }}
                              </td>
                              <td style="padding-left: 0; padding-right: 30px;">
                                  <div class="material-switch repeating-bookings">
                                      <input class="fields-checkbox" name="repeated-bookings-data" :id="'fields-checkbox-repeat' + index" type="checkbox" :value="recurring.booking_id" @change="handleCheckboxChange(recurring.booking_id)">
                                      <label :for="'fields-checkbox-repeat' + index" :data-id="index" class="label-default-repeat"></label>
                                  </div>
                              </td>
                          </tr>
                      </tbody>

                  </table>
              </div>
          </div>
      </div>
      <div class="row">
          <div class="col-md-12 recurring-fieldworker no-padding-left">
              <div class="form-group">
                  <div class="col-xs-12 col-md-12">
                      <div class="material-switch repeating-bookings-assign-fieldworker"  style="float: left">
                          <input id="fields-checkbox-repeating_fieldworker"  value="repeating_fieldworker" name="" class="fields-checkbox" type="checkbox" v-model="assignFieldworker"  @change="toggleAssignFieldworker"/>
                          <label for="fields-checkbox-repeating_fieldworker" class="label-default-new-repeating"></label>
                          <span class="assign-fieldworker"> Assign a {{ workersNameSingular}} to all future related recurring bookings</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import {getRepeatingBookings} from "@/modules/Booking/api/repeatingBookings/";
import {EventBus} from "@/events/event-bus";
import ConfirmationPopup from "../../../common/components/ConfirmationPopup.vue";
export default {
    name: "repeatBookingsModal",
    props: {
      recurringBookings:null,
      workersNameSingular:null,
    },
    data() {
        return {
            checkedRepeating: [], // Array to hold checked items
            selectAll: false,
            assignFieldworker: false,
        };
    },
    methods: {
        handleCheckboxChange(value) {
            if (this.checkedRepeating.includes(value)) {
                // Item already exists, remove it
                const index = this.checkedRepeating.indexOf(value);
                this.checkedRepeating.splice(index, 1);
            } else {
                // Item doesn't exist, add it
                this.checkedRepeating.push(value);
            }
            EventBus.$emit('ListenRepeatBookingChecked', this.checkedRepeating);
        },
        toggleSelectAll() {
            if (this.selectAll) {
                // If selectAll is true, add all booking_ids to checkedrepeating
                this.checkedRepeating = this.recurringBookings.map(recurring => recurring.booking_id);
            } else {
                // If selectAll is false, empty checkedrepeating
                this.checkedRepeating = [];
            }
            EventBus.$emit('ListenRepeatBookingChecked', this.checkedRepeating);
        },
        toggleAssignFieldworker() {
            if (this.assignFieldworker) {
                // If selectAll is true, add all booking_ids to checkedrepeating
                $("#assign_repeating_fieldworker").val(1);
            } else {
                // If selectAll is false, empty checkedrepeating
                $("#assign_repeating_fieldworker").val(0);
            }
        }
    }
}
</script>
<style scoped>
.recurring-fieldworker {
    text-align: left;
    font-size: 15px;
    padding: 20px 5px;
    font-weight: 700;

}
.assign-fieldworker{
    margin-left: 50px;
}
.repeating-booking-hint{
    font-weight: 700;
    font-size: 15px;
}
.material-switch.repeating-bookings{
    text-align: center;
}
.material-switch.repeating-bookings > input[type="checkbox"] {
    display: none;
}

.material-switch.repeating-bookings > label {
    cursor: pointer;
    height: 0px;
    position: relative;
    width: auto;
}

.material-switch.repeating-bookings > label::before {
    background: #cacfd3;
    /*box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.5);*/
    border-radius: 8px;
    content: '';
    height: 16px;
    margin-top: -8px;
    position: absolute;
    opacity: 0.3;
    transition: all 0.4s ease-in-out;
    width: 40px;
}

.material-switch.repeating-bookings > label::after {
    background: rgb(255, 255, 255);
    border-radius: 16px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
    content: '';
    height: 24px;
    left: -4px;
    margin-top: -8px;
    position: absolute;
    top: -4px;
    transition: all 0.3s ease-in-out;
    width: 24px;
}


.material-switch.repeating-bookings > input[type="checkbox"]:checked + label::before {
    background: #cacfd3 !important;
    opacity: 0.5;
}

.material-switch.repeating-bookings > input[type="checkbox"]:checked + label::after {
    background: #2e4050;
    left: 20px;
}

.material-switch.repeating-bookings-assign-fieldworker > input[type="checkbox"]:checked + label::before {
    background: #cacfd3 !important;
    opacity: 0.5;
}

.material-switch.repeating-bookings-assign-fieldworker > input[type="checkbox"]:checked + label::after {
    background: #2e4050;
    left: 20px;
}


.material-switch.assign-fieldworker{
    text-align: center;
}
.material-switch.assign-fieldworker > input[type="checkbox"] {
    display: none;
}

.material-switch.assign-fieldworker > label {
    cursor: pointer;
    height: 0px;
    position: relative;
    width: auto;
}

.material-switch.assign-fieldworker > label::before {
    background: #cacfd3;
    /*box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.5);*/
    border-radius: 8px;
    content: '';
    height: 16px;
    margin-top: -8px;
    position: absolute;
    opacity: 0.3;
    transition: all 0.4s ease-in-out;
    width: 40px;
}

.material-switch.assign-fieldworker > label::after {
    background: rgb(255, 255, 255);
    border-radius: 16px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
    content: '';
    height: 24px;
    left: -4px;
    margin-top: -8px;
    position: absolute;
    top: -4px;
    transition: all 0.3s ease-in-out;
    width: 24px;
}

.material-switch.assign-fieldworker > input[type="checkbox"]:checked + label::before {
    background: inherit;
    opacity: 0.5;
}

.material-switch.assign-fieldworker > input[type="checkbox"]:checked + label::after {
    background: #2e4050;
    left: 20px;
}
</style>